import { StateResolver, StateResolverContext } from '@workspace/core-ts/types';
import { StepProps, getStepBySlug } from '@workspace/core-ts/utils';

/**
 * Résolveur d'état spécifique au formulaire de livraison
 * Contient toute la logique de navigation et de résolution d'étapes
 * spécifique au processus de livraison
 */
export class LivraisonStateResolver implements StateResolver {
  resolveStepFromState(
    state: string,
    context: StateResolverContext
  ): StepProps | null {
    const { isAvenant, finalForm, source, steps } = context;
    
    let possibleStep: StepProps | null = null;
    
    // Logique spécifique au formulaire de livraison
    switch (state) {
      case 'new':
        if (isAvenant) {
          possibleStep = getStepBySlug('avenant', steps);
        } else {
          possibleStep = getStepBySlug('bienvenue', steps);
        }
        break;

      /* Etape de tarif avant paiement */
      case 'tarif':
      case 'devis_orange':
        possibleStep = getStepBySlug('tarification', steps);
        break;

      /* Recapitulatif avant paiement */
      case 'devis':
        if (finalForm.DemandeTarif?.Subscribe || source === 'site') {
          possibleStep = getStepBySlug('recapitulatif', steps);
        } else {
          possibleStep = getStepBySlug('vehicules', steps);
        }
        break;

      /* save_devis fait, en attente du paiement */
      case 'contrat_en_attente_de_paiement':
          if (isAvenant) {
              // Pour les avenants : validation automatique (mutationPay au mount)
              possibleStep = getStepBySlug('validation-paiement-avenant', steps);
          } else  {
              if (source === 'site') {
                  possibleStep = getStepBySlug('validation', steps);
              } else {
                  possibleStep = getStepBySlug('attente-paiement', steps);
              }
          }
        break;

      /* retour du paiement en attente de la validation pour signature */
      case 'contrat_en_cours_de_validation':
      case 'contrat':
        possibleStep = getStepBySlug('validation', steps);
        break;
      
      default:
        // Si l'état n'est pas reconnu, ne pas changer d'étape
        possibleStep = null;
    }
    
    return possibleStep;
  }

}
